module.exports = __webpack_public_path__ + "img/products_and_memberships.8363deef.svg";